//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BcCheckStatus from '../common/BcCheckStatus.vue'
import SmallEmployer from './SmallEmployer.vue'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'SingleTaskTitle',
  components: {
    BcCheckStatus,
    SmallEmployer
  },
  props: {
    task: {
      type: Object,
      default () {
        return null
      }
    },
    client: {
      type: Object,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    }
  },
  computed: {
    clientData () {
      return this.client ? this.client : this.task.client
    }
  }
}
